export enum FiOnboardingCategoryType {
    Independent = 0,
    SyncReady = 1,
    Synchronized = 2,
}

export enum FiOnboardingDisplayType {
    HomePage = 0,
    OnboardingPage = 1,
}

export enum FiOnboardingStepNotificationRecipientType {
    Roles = 0,
    RolesLocal = 1,
    Users = 2,
    EmailAddress = 3,
    SMS = 4,
    Participants = 5, // todo make separate enum?
}

export enum FiOnboardingStepNotificationReminderTime {
    Completed = 0,
    OneDay = 1,
    ThreeDays = 2,
    SevenDays = 3,
}

export enum FiOnboardingStatusType {
    NotStarted = 0,
    InProgress = 1,
    Completed = 2,
    NotAvailable = 255,
}

export enum FiSourceOnboardingStepConditionType {
    Completed = 0,
    NotCompleted = 1,
}

export enum FiTargetOnboardingStepActionType {
    Activate = 0,
    Disable = 1,
}
